import React, { useState, useEffect, useContext, useRef } from "react";
import "./TeaserForm.scss";

import { Redirect } from "react-router";

import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";
import Button from "../../ui/Button/Button";
import Checkbox from "../../ui/Checkox/Checkbox";
import Select from "../../ui/Select/Select";
import InputField from "../../ui/InputField/InputField";
import CpcInputField from "../../ui/InputField/CpcInputField";
import FormMessage from "../../ui/FormMessage/FormMessage.js";

import { FixedHeader, PrimaryHeader, SecondaryHeader } from "../../ui/Header";

import * as urls from "../../utils/urls";

import TeaserForm from "../../ui/TeaserForm/TeaserForm";
import CampaignOverview from "../../ui/CampaignOverview/CampaignOverview";
import TeaserCopyTo from "../../ui/TeaserCopyTo/TeaserCopyTo";

import useFormState from "../../hooks/useFormState";
import useCopyToEffect from "../../effects/useCopyToEffect";
import useCampaignInfoEffect from "../../effects/useCampaignInfoEffect";
import useFormSaveEffect from "../../hooks/useFormSaveEffect";

import TeaserCopyToComponent from "../../components/TeaserCopyToComponent";

import {
  TeaserSaveService,
  MyCardsService,
  SetCidWorkOnService
} from "../../utils/api";

import CampaignSelect from "../../components/CampaignsSelect";

import moment from "moment";

import NotificationContext from "../../context/NotificationContext";

import IfPermission from "../../components/IfPermission";
import * as perm from "../../utils/perm";
import { teaserStatus } from "../../constants";

import usePermissions from "../../hooks/usePermissions";
import useCampaignsSelect from "../../hooks/useCampaignsSelect";
import useEventEmitter from "../../hooks/useEventEmitter";
import useThis from "../../hooks/useThis";
import useTitle from "../../hooks/useTitle";

import { useTeaserFormSpellChecker } from "../../hooks/useTeaserFormSpellChecker";

function isValid(fields) {
  return (
    !!fields.cid &&
    !!fields.category &&
    !!fields.title &&
    !!fields.image &&
    !!fields.url &&
    !!(fields.type != undefined || fields.type != null || fields.type != "")
  );
}

const publishedOptions = [
  { label: "Активный", value: teaserStatus.active },
  { label: "Неактивный", value: teaserStatus.inactive },
  { label: "Отклонен", value: teaserStatus.reject },
  { label: "На модерации", value: teaserStatus.moderate },
  { label: "Удален", value: teaserStatus.delete }
];

const TeaserFormView = ({ light }) => {
  const [fields, setFields] = useState({ type: 2 }); // in by default
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [redirect, setRedirect] = useState(null);
  const permissions = usePermissions();
  const notificationContext = useContext(NotificationContext);

  const spellChecker = useTeaserFormSpellChecker();

  const {
    info: campaignInfo,
    loading: campaignInfoLoading
  } = useCampaignInfoEffect(fields.cid);
  const campaignsSelect = useCampaignsSelect(fields.cid);
  const eventEmitter = useEventEmitter();

  const thisCid = useThis(fields.cid);

  const fieldsRef = useRef(fields);

  useTitle("Добавление анонса (CNTN.)");

  useEffect(() => {
    fieldsRef.current = fields;
  }, [fields]);

  useEffect(() => {
    if (fields.cid) {
      SetCidWorkOnService(fields.cid);
    }
  }, [fields.cid]);

  const handleSubmit = () => {
    const submit = () => {
      setLoading(true);

      TeaserSaveService(fields)
        .then(() => {
          setSaved(true);
        })
        .catch(e => {
          if (e.code == "CAMPAIGN_NOT_ALLOWED") {
            notificationContext.showSimpleNotification({
              color: "red",
              title: "Ошибка",
              text: "Кампания запрещена"
            });
            setRedirect(urls.teaserList());
          } else {
            e.errors && setErrors(e.errors);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    };

    spellChecker.onSubmit({ submit, fields });
  };

  const onChange = payload => {
    setFields({ ...fields, ...payload });
  };

  const onCampaignChange = selected => {
    setFields({ ...fieldsRef.current, cid: selected.value });
  };

  const onPublishedChange = selected => {
    setFields({ ...fields, published: selected.value });
  };

  useEffect(() => {
    if (!campaignInfoLoading) {
      setFields(prev => {
        const published = campaignInfo.teaser_autostart
          ? teaserStatus.active
          : teaserStatus.inactive;
        return { ...prev, published };
      });
    }
  }, [campaignInfoLoading]);

  const checkEnabled = initial => {
    MyCardsService()
      .then(cards => {
        if (cards.length == 0) {
          campaignsSelect.setDisabled(true);
          setFields(prev => ({ ...prev, cid: "" }));
          return;
        }

        if (initial) {
          campaignsSelect.setDisabled(false);
          setFields(prev => ({ ...prev, cid: cards[0].id }));
          return;
        }

        const ids = cards.map(c => c.id);

        if (!ids.includes(thisCid.current)) {
          campaignsSelect.setDisabled(false);
          setFields(prev => ({ ...prev, cid: "" }));
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (!perm.hasAnyCampaignAccess(permissions)) {
      checkEnabled(true);

      /* const check = () => {
             *     checkEnabled();
             * };

             * eventEmitter.subscribe("cards_update", check);

             * return () => {
             *     eventEmitter.unsubscribe("cards_update", check);
             * }; */
    }
  }, []);

  const showSelectPerm = permissions => {
    return (
      perm.canSkipModeration(permissions) || perm.canSetAnyStatus(permissions)
    );
  };

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  if (saved) {
    const redirectTo = {
      pathname: urls.teaserList(),
      search: `teasers_cid=${fields.cid}`
    };
    return <Redirect to={redirectTo} />;
  }

  return (
    <div className="teaser-form-view">
      <FixedHeader className="teaser-form-header">
        <PrimaryHeader>
          <span className="header__title">Создание анонса</span>
          <IfPermission checker={perm.canViewAggregator}>
            <ButtonGroup
              items={[
                { title: "Вручную", code: urls.teaserAdd(), exact: true },
                { title: "Агрегатор", code: urls.teaserAddAggregator() }
              ]}
              theme={"dark"}
              selected="add"
              nav
            />
          </IfPermission>

          <div className={"teaser-form-view__header-right"}>
            <IfPermission checker={showSelectPerm}>
              <Select
                className="teaser-form-view__status-change"
                disabled={!perm.canSetAnyStatus(permissions)}
                theme={light ? "" : "dark"}
                className="teaser-edit__status"
                value={fields.published}
                options={publishedOptions}
                onSelect={onPublishedChange}
              />
            </IfPermission>

            <Button
              className="teaser-form-view__create-btn"
              color="green"
              disabled={!isValid(fields)}
              onClick={handleSubmit}
            >
              Создать анонс
            </Button>
          </div>
        </PrimaryHeader>

        <SecondaryHeader>
          <div className="teaser-form-view__meta-wrapper">
            <Select
              className="campaign"
              placeholder="Выбор кампании"
              onSelect={onCampaignChange}
              value={fields.cid}
              {...campaignsSelect}
            />
            <Checkbox id="chb1">Сохранить выбор</Checkbox>
            <CampaignOverview
              info={campaignInfo}
              loading={campaignInfoLoading}
            />
          </div>
        </SecondaryHeader>
      </FixedHeader>
      <div className="content-body teaser-form-view__body">
        <TeaserForm
          fields={fields}
          onChange={onChange}
          errors={errors}
          campaignInfo={campaignInfo}
          spellChecker={spellChecker}
        />
        {/*<TeaserCopyToComponent campaigns={copyToCampaigns} loading={copyToLoading} onChange={onCopyToChange} />*/}
      </div>
    </div>
  );
};

export default TeaserFormView;
